
// 我的流程
<template>
	<div id="containt">



				<div class="grid-height" style="display:flex">
					<!-- 左边------- 树型结构 -->
					<div class="left_tree">

						<div style="padding: 5px;margin: 0px 8px;height: 100vh;border: 1px solid #ededed;">
							<div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
									version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
									<path
										d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
										fill="#1296db" p-id="2888"></path>
								</svg>

								<span>流程管理</span>
							</div>
							<el-input placeholder="关键字过滤" v-model="filterText">
							</el-input>

							<el-tree class="tree-line" :data="data" :lazy="true" :load="loadChildNode" :props="defaultProps" 
								@node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
								<span class="custom-tree-node" slot-scope="{ node, data }">
									<span>{{ node.label }}</span><span>[{{node.data.qty}}]</span>
								</span>
							</el-tree>
						</div>
					</div>
					<div class="table_main" style="height: calc(100vh - -71px);">
						<vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<!-- <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
											@click="openEditDialog">新增</vxe-button> -->
											<span>流程列表</span><span style="color: #666666;">(共{{total}}条记录)</span>
									</div>
									<div class="fr">

										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
									<vxe-form-item title="单号:" field="brandName">
										<template v-slot>
											<el-input v-model="formData.orderNo" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="流程名称:" field="itemCode">
										<template v-slot>
											<el-input v-model="formData.wfName" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="当前节点:" field="itemName">
										<template v-slot>
											<el-input v-model="formData.taskName" size="small" clearable />
										</template>
									</vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>

    <wfDialog :processId="processId" v-if="showWfDialog"  @closeWfDialog="closeWfDialog" :wfData="wfData"
              :visiable.sync="showWfDialog" multi="true"/>
	</div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import wfDialog from "@/views/dialogCommon/wfDialog.vue";
export default {
	name: 'myFlow',
	components: { pager,wfDialog },
	data() {
		return {
			processId:'',
			first: true,
      		total: 0,
			filterText: '',
			data: [],
			showWfDialog:false,
			wfData:{},
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
        		qty:"qty",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
				current: 1,
				searchCount: true,
        		type:1
			},
		};
	},
	mounted() {
		// this.initTableList();
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
	},
	methods: {
		toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
		// el-tab 监视切换事件
		handleClick(tab, event) {
			console.log(tab, event);

		},
    toShowWf(row){
        this.wfData = row;
		this.processId=row.wfEntityId
		console.log(this.wfData,"this.wfData  id");
        this.showWfDialog = true;
    },
    closeWfDialog(type){
		this.$refs['table-m1'].commitProxy('reload');

      this.showWfDialog = type;

    },
		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = true
			// this.initTableList();
				// this.initTableList();
				if (!this.first) {
					this.initTableList()
				}
				this.first = false

			// this.$refs['table-m1'].commitProxy('reload');
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		// 搜索
		searchEvent() {
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.$refs.pager.reset()  // 重置分页器

			this.$refs['table-m1'].commitProxy('reload');

		},
		// 重置
		resetEvent() {
			this.formData = {};
			this.formData.addresswangdian = {};
			this.$refs.pager.reset()  // 重置分页器
			this.$refs['table-m1'].commitProxy('reload');
		},
		// 点击的树形 点
		handleNodeClick(node, data) {
			if (data.level === 1) {
				// this.formData={};
				this.formData.type = node.id;
			} else {
				this.formData.type = node.parentId;
        		this.formData.tableKey = node.tableKey;
			}
			if (data.level>1){
				this.initTableList();
				this.$refs['table-m1'].commitProxy('reload');
			}
		},

		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/act/indexTask/getMyWfTasks',
				param: this.formData,
				method: 'post',

				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '单号',
						field: 'orderNo',
						width: 200,
						// fixed: 'left'
					},
					{
						title: '流程名称',
						field: 'wfName',
						width: 120,
					},
					{
						title: '当前节点',
						field: 'taskName',
						width: 120,
					},
					{
						title: '启动用户',
						field: 'startUserName',
						width: 120,
					},
					{
						title: '机构',
						field: 'orgName',
						width: 120,
					},
					{
						field: 'createTime',
						title: '启动时间',
						width: 150
					},
										{
						title: '状态',
						field: 'stat',
						width: 120,
						slots: {
							default: ({ row }) => {
								if (row.stat == 2) {
									return [
										<div class="txt-status disable">
											<span>结束</span>
										</div>
									];
								} else if (row.stat == 1) {
									return [
										<div class="txt-status">
											<span>审核中</span>
										</div>
									];
								}
							}
						}
					},

					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.toShowWf(row);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
			this.$refs['table-m1'].commitProxy('reload');
			// console.log(initVxeTable(tableOption),"vxeOption-表头的值及属性");
			// });
		},
		// 获取树形数据
		loadChildNode(node, resolve) {
			console.log("node===", node)
			console.log("node.level", node.level)
			if (node.level > 1) {
				return resolve([]);
			}
			var query = JSON.parse(JSON.stringify(this.formData));
			if (node.level == 1) {
				this.formData.type = node.id
				query.type = node.id
			} else {
				this.formData.type = node.data.parentId
				query.type = node.data.parentId
			}

			this.$http({
				url: "/act/indexTask/getAllWf",
				method: 'post',
				data: query,
			}).then(res => {
				var result = res.data.data.map(item => {
						return {
							label: item.nodeName,
							id: item.id,
							leaf: Number(item.isChild) == 1 ? false : true,
							qty: item.qty,
							parentId: item.parentId,
							tableKey: item.tableKey
						}
					})
				resolve(
					result
				)
			})
		},
	}
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 300px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>

